module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/pathology-9eff73f30b8d28c8100141d710f2a597.jpeg";